export default "__VITE_ASSET__C8V5bqvY__"